import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { OptionsService } from '../../options/services/options.service'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'
import { setStrokeScaleNeuroOptions } from '../store/options.actions'

export function* getStrokeScaleNeuroOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getStrokeScaleOptions])
    const { entity } = response
    yield put(setStrokeScaleNeuroOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getStrokeScaleNeuroOptions() error: ${e}`))
  }
}

export function* getStrokeScaleNeuroOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getStrokeScaleNeuroOptions)
}
